module.exports = __webpack_public_path__ + "b683029bafe0305ac2234038a03e1541.woff";